import React from 'react';

function FallbackScreen(props) {
    return (
        <div className="preloader"></div>
    );
}

export default FallbackScreen;